import React, { InputHTMLAttributes } from 'react';
import clsx from 'clsx';

interface InputTextProps extends InputHTMLAttributes<HTMLInputElement> {
  branchColour?: string;
  name?: string;
  isRequired?: boolean;
  ref?: string;
  className?: string;
  // onChange must be assign in here as void
}

const InputText = ({
  branchColour,
  name,
  isRequired,
  ref,
  className,
  ...rest
}: InputTextProps) => {
  const classNameOnInput = (name: string) => {
    switch (name) {
      case 'weight':
        return `flex-shrink flex-grow
        relative
        leading-normal
        px-3
        py-2
        border border-gray-300
        rounded-md
        shadow-sm
        placeholder-gray-400
        focus:outline-none
        rounded-r-none
        sm:text-sm
        w-full
      bg-white`;
      case 'volume':
        return `flex-shrink flex-grow
        relative
        leading-normal
        px-3
        py-2
        border border-gray-300
        rounded-md
        shadow-sm
        placeholder-gray-400
        focus:outline-none
        rounded-r-none
        sm:text-sm
        w-full
      bg-white`;
      case 'price':
        return `flex-shrink flex-grow
      relative
      leading-normal
      px-3
      py-2
      border border-gray-300
      rounded-md
      shadow-sm
      placeholder-gray-400
      focus:outline-none
      rounded-l-none
      sm:text-sm
      w-full
    bg-white`;
      default:
        return `block
    w-full
    appearance-none
    rounded-md
    border
    border-gray-300
    px-3
    py-2
    placeholder-gray-400
    shadow-sm focus:outline-none
    sm:text-sm`;
    }
  };

  return (
    <input
      className={clsx(classNameOnInput(name), className)}
      style={{
        transition: 'border-color 0.3s, box-shadow 0.3s',
      }}
      onFocus={(e) => {
        (e.currentTarget as HTMLInputElement).style.borderColor = branchColour;
        (
          e.currentTarget as HTMLInputElement
        ).style.boxShadow = `0 0 0 2px ${branchColour}`;
      }}
      onBlur={(e) => {
        (e.currentTarget as HTMLElement).style.borderColor = '';
        (e.currentTarget as HTMLElement).style.boxShadow = '';
      }}
      name={name}
      required={isRequired}
      ref={ref}
      {...rest}
    />
  );
};

export default InputText;
